"use client";

import { useSyncExternalStore } from "react";
import { cn } from "@/lib/cn";
import { markdownToHtml } from "@/lib/markdown";
import { sanitizeHtml } from "@/lib/sanitize";

export interface MarkdownContentProps {
  content: string;
  className?: string;
  testId?: string;
}

const emptySubscribe = () => () => {};

const BASE_CLASS =
  "prose prose-sm max-w-none [&_a]:text-gold-600 [&_a]:underline [&_blockquote]:border-ink-200 [&_blockquote]:border-l-4 [&_blockquote]:pl-4 [&_blockquote]:italic [&_h2]:mt-6 [&_h2]:text-xl [&_h2]:font-semibold [&_h2]:text-ink-900 [&_h3]:mt-4 [&_h3]:text-lg [&_h3]:font-semibold [&_h3]:text-ink-900 [&_img]:rounded-md [&_ol]:list-decimal [&_ol]:pl-6 [&_ul]:list-disc [&_ul]:pl-6 text-ink-700 leading-relaxed";

export function MarkdownContent({
  content,
  className,
  testId,
}: MarkdownContentProps) {
  const sanitized = sanitizeHtml(markdownToHtml(content));

  const html = useSyncExternalStore(
    emptySubscribe,
    () => sanitized,
    () => "",
  );

  return (
    <div
      data-testid={testId}
      className={cn(BASE_CLASS, className)}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}
